import { ISystemHeaderFieldsProps } from "./ISystemHeaderFieldsProps";

export const useSystemHeaderFieldsViewModel = (
  props: ISystemHeaderFieldsProps
) => {
  /**
   * if input fields are undefined and then later change to a value, they need
   * initializing beforehand as a string to avoid an uncontrolled error
   * */
  return {
    client: props.system?.SYSTEM_CLIENT ?? "",
    editMode: props.editMode,
    installNumber: props.system?.INSTNUMBER ?? "",
    inputFieldErrorSid: props.inputFieldErrorSid,
    inputFieldErrorClient: props.inputFieldErrorClient,
    inputFieldErrorInstallNumber: props.inputFieldErrorInstallNumber,
    inputFieldErrorDescription: props.inputFieldErrorDescription,
    inputFieldErrorTotalSystemsCount: props.inputFieldErrorTotalSystemsCount,
    inputFieldErrorProductionSystemsCount:
      props.inputFieldErrorProductionSystemsCount,
    showZeroSystemsWarning: props.showZeroSystemsWarning ?? false,
    setClient: props.onSetClient,
    setInstallNumber: props.onSetInstallNumber,
    setDescription: props.onSetDescription,
    setSid: props.onSetSid,
    setTotalSystemsCount: props.onSetTotalSystemsCount,
    setProductionSystemsCount: props.onSetProductionSystemsCount,
    showTotalSystemsCount: props.showTotalSystemsCount ?? false,
    showProductionSystemsCount: props.showProductionSystemsCount ?? false,
    systemId: props.system?.SYSTEM_ID ?? "",
    description: props.system?.DESCRIPTION ?? "",
    totalSystemsCount: props.system?.LIC_TOT_COUNT ?? "",
    productionSystemsCount: props.system?.LIC_PRD_COUNT ?? "",
  };
};
